import { useCallback } from 'react';
import { CUSTOM_CATEGORIES } from 'utils/constants/casino/custom-categories';
import { mountPoint } from 'utils/generic/route-manipulation';
import { ECasinoGameMode, ECasinoGameView } from 'interfaces/casino-data';
import { NewCasinoGame } from 'interfaces/new-casino';
import { UtilsCasino } from 'newelements/Casino/GameSingleViewRenderer/__partials/GameViewContainer/utils';
import { useSearchParams } from 'hooks/useSearchParams';
import { useSbRouteMatch } from 'newhooks/generic/useSbRouteMatch';
import { useCasinoOpenGameConfigsValues } from 'providers/casino/openGameConfigsProvider';

export const useOpenCasinoGame = () => {
  const { tournamentId } = useSearchParams();
  const externalContext = useCasinoOpenGameConfigsValues();
  const routeMatchCategory = useSbRouteMatch(
    `${mountPoint(location.pathname, false, true)}/:category`
  );

  return useCallback(
    (mode: ECasinoGameMode, game: NewCasinoGame) => {
      if (externalContext.onOpenGame) {
        externalContext.onOpenGame(game, mode);

        return;
      }

      const category =
        routeMatchCategory?.params?.category || CUSTOM_CATEGORIES.all.id;

      const tournament = tournamentId ? { id: tournamentId } : undefined;

      UtilsCasino.constructAndRedirectToGameView({
        game,
        mode,
        selectedCategory: category,
        view: ECasinoGameView.SINGLE,
        tournament
      });
    },
    [tournamentId, routeMatchCategory, tournamentId]
  );
};
